export const dayTranslations: Record<string, Record<string, string>> = {
  en: {
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  fr: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Jeu',
    Fri: 'Ven',
    Sat: 'Sam',
    Sun: 'Dim',
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
    Sunday: 'Dimanche',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sat: 'Sam',
    sun: 'Dim',
  },
};

export const weekTranslations: Record<string, Record<string, string>> = {
  en: {
    'Week 1': 'Week 1',
    'Week 2': 'Week 2',
    'Week 3': 'Week 3',
    'Week 4': 'Week 4',
    'Week 5': 'Week 5',
    'week 1': 'Week 1',
    'week 2': 'Week 2',
    'week 3': 'Week 3',
    'week 4': 'Week 4',
    'week 5': 'Week 5',
    Week1: 'Week 1',
    Week2: 'Week 2',
    Week3: 'Week 3',
    Week4: 'Week 4',
    Week5: 'Week 5',
    week1: 'Week 1',
    week2: 'Week 2',
    week3: 'Week 3',
    week4: 'Week 4',
    week5: 'Week 5',
  },
  fr: {
    'Week 1': 'Semaine 1',
    'Week 2': 'Semaine 2',
    'Week 3': 'Semaine 3',
    'Week 4': 'Semaine 4',
    'Week 5': 'Semaine 5',
    'week 1': 'Semaine 1',
    'week 2': 'Semaine 2',
    'week 3': 'Semaine 3',
    'week 4': 'Semaine 4',
    'week 5': 'Semaine 5',
    Week1: 'Semaine 1',
    Week2: 'Semaine 2',
    Week3: 'Semaine 3',
    Week4: 'Semaine 4',
    Week5: 'Semaine 5',
    week1: 'Semaine 1',
    week2: 'Semaine 2',
    week3: 'Semaine 3',
    week4: 'Semaine 4',
    week5: 'Semaine 5',
  },
};

export const monthTranslations: Record<string, Record<string, string>> = {
  en: {
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  fr: {
    Jan: 'Jan',
    Feb: 'Fév',
    Mar: 'Mar',
    Apr: 'Avr',
    May: 'Mai',
    Jun: 'Juin',
    Jul: 'Juil',
    Aug: 'Août',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Déc',
    jan: 'Jan',
    feb: 'Fév',
    mar: 'Mar',
    apr: 'Avr',
    may: 'Mai',
    jun: 'Juin',
    jul: 'Juil',
    aug: 'Août',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Déc',
    January: 'Janvier',
    February: 'Février',
    March: 'Mars',
    April: 'Avril',
    June: 'Juin',
    July: 'Juillet',
    August: 'Août',
    September: 'Septembre',
    October: 'Octobre',
    November: 'Novembre',
    December: 'Décembre',
  },
};

export const timeRangeTranslations: Record<string, Record<string, string>> = {
  en: {
    '12-3 AM': '12-3 AM',
    '3-6 AM': '3-6 AM',
    '6-9 AM': '6-9 AM',
    '9-12 AM': '9-12 AM',
    '12-3 PM': '12-3 PM',
    '3-6 PM': '3-6 PM',
    '6-9 PM': '6-9 PM',
    '9-12 PM': '9-12 PM',
    '12-3 AM ': '12-3 AM',
    '3-6 AM ': '3-6 AM',
    '6-9 AM ': '6-9 AM',
    '9-12 AM ': '9-12 AM',
    '12-3 pm': '12-3 PM',
    '3-6 pm': '3-6 PM',
    '6-9 pm': '6-9 PM',
    '9-12 pm': '9-12 PM',
    '12-3 am': '12-3 AM',
    '3-6 am': '3-6 AM',
    '6-9 am': '6-9 AM',
    '9-12 am': '9-12 AM',
  },
  fr: {
    '12-3 AM': '0h-3h',
    '3-6 AM': '3h-6h',
    '6-9 AM': '6h-9h',
    '9-12 AM': '9h-12h',
    '12-3 PM': '12h-15h',
    '3-6 PM': '15h-18h',
    '6-9 PM': '18h-21h',
    '9-12 PM': '21h-24h',
    '12-3 AM ': '0h-3h',
    '3-6 AM ': '3h-6h',
    '6-9 AM ': '6h-9h',
    '9-12 AM ': '9h-12h',
    '12-3 pm': '12h-15h',
    '3-6 pm': '15h-18h',
    '6-9 pm': '18h-21h',
    '9-12 pm': '21h-24h',
    '12-3 am': '0h-3h',
    '3-6 am': '3h-6h',
    '6-9 am': '6h-9h',
    '9-12 am': '9h-12h',
  },
};

export const translateChartLabels = (
  labels: string[],
  view:
    | 'daily'
    | 'day'
    | 'weekly'
    | 'week'
    | 'monthly'
    | 'month'
    | 'year'
    | 'yearly',
  language: string,
): string[] => {
  const lang = language in dayTranslations ? language : 'en';

  let translationDict: Record<string, Record<string, string>>;
  switch (view) {
    case 'daily':
    case 'day':
      translationDict = timeRangeTranslations;
      break;
    case 'weekly':
    case 'week':
      translationDict = dayTranslations;
      break;
    case 'monthly':
    case 'month':
      translationDict = weekTranslations;
      break;
    case 'yearly':
    case 'year':
      translationDict = monthTranslations;
      break;
    default:
      return labels;
  }

  return labels.map((label) => {
    if (!label) return '';

    if (process.env.NODE_ENV === 'development') {
      console.debug(
        `Translating label: "${label}" in view: ${view}, lang: ${lang}`,
      );
    }

    const normalizedLabel = label.trim();

    if (translationDict[lang][normalizedLabel]) {
      return translationDict[lang][normalizedLabel];
    }

    if (view === 'weekly' && normalizedLabel.length === 3) {
      const formattedDay =
        normalizedLabel.charAt(0).toUpperCase() +
        normalizedLabel.slice(1).toLowerCase();
      if (translationDict[lang][formattedDay]) {
        return translationDict[lang][formattedDay];
      }
    }

    if (view === 'yearly' && normalizedLabel.length === 3) {
      const formattedMonth =
        normalizedLabel.charAt(0).toUpperCase() +
        normalizedLabel.slice(1).toLowerCase();
      if (translationDict[lang][formattedMonth]) {
        return translationDict[lang][formattedMonth];
      }
    }

    if (
      view === 'monthly' &&
      /^week\s*\d+$/i.test(normalizedLabel.toLowerCase())
    ) {
      const weekNumber = normalizedLabel
        .toLowerCase()
        .replace(/week\s*/i, '')
        .trim();
      const standardFormat = `Week ${weekNumber}`;
      if (translationDict[lang][standardFormat]) {
        return translationDict[lang][standardFormat];
      }
    }

    if (
      view === 'daily' &&
      /\d+-\d+\s*(am|pm)/i.test(normalizedLabel.toLowerCase())
    ) {
      const variations = [
        normalizedLabel,
        normalizedLabel.toUpperCase(),
        normalizedLabel.toLowerCase(),
        normalizedLabel.replace(/\s+/g, ' ').trim(),
      ];

      for (const variant of variations) {
        if (translationDict[lang][variant]) {
          return translationDict[lang][variant];
        }
      }
    }

    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `No translation found for "${label}" in ${view} view and ${lang} language`,
      );
    }
    return label;
  });
};
